export default function IconChips({webURL, image, techName}){
    const redirectToWebsite = () => {
        //window.location.href = webURL;
        window.open(webURL, '_blank')
    }
    
    return(<div onClick={redirectToWebsite} className="technologies-card glass rounded-full animate-pulse">
        <img src={image} alt={techName + " Logo"} className="m-auto h-full w-auto p-2" draggable="false"/>
        </div>)
}